import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

export const isCourseStarted = (course?: Nullable<CourseApiModel>) => {
  return course?.status === 'ongoing' || course?.status === 'paused';
};
